export default function () {
  this.loadBoost()
}
